import { render, staticRenderFns } from "./AcceptSuccessPage.vue?vue&type=template&id=e71e7ab4&scoped=true&"
import script from "./AcceptSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./AcceptSuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptSuccessPage.vue?vue&type=style&index=0&id=e71e7ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71e7ab4",
  null
  
)

export default component.exports